export const equalSymbolCheckReg = /(?:^|[^><=])(=)(?![><=])/g;
